import { LegalShell, LegalSection, LegalList } from "@/components/site/LegalShell";

export default function PrivacyPolicy() {
  return (
    <LegalShell
      title="Privacy Policy"
      updated="June 2026"
      seoTitle="Privacy Policy | AYOBELL"
      seoDesc="How AYOBELL and TechSpace Solutions Ltd collect, use and protect personal information submitted through this website."
    >
      <LegalSection>
        <p>This Privacy Policy explains how AYOBELL, a product of TechSpace Solutions Ltd ("we", "us", "our"), collects and uses personal information you provide through this marketing website (ayobell.com). It does not describe the processing carried out within the AYOBELL care management application itself, which is governed by separate agreements with customer organisations.</p>
      </LegalSection>

      <LegalSection heading="Information we collect">
        <p>When you contact us or request a demo through this website, we collect the details you submit, which may include:</p>
        <LegalList items={[
          "Your name and organisation",
          "Work email address and telephone number",
          "Type of service, number of locations and approximate number of service users",
          "Any message or enquiry details you choose to provide",
        ]} />
      </LegalSection>

      <LegalSection heading="How we use your information">
        <p>We use the information you provide to:</p>
        <LegalList items={[
          "Respond to your enquiry and arrange a demonstration of AYOBELL",
          "Understand your requirements so we can tailor information and pricing",
          "Improve our website and services",
        ]} />
        <p>We will not sell your information or share it with third parties for their own marketing.</p>
      </LegalSection>

      <LegalSection heading="Lawful basis">
        <p>We process demo and contact enquiries on the basis of taking steps at your request prior to entering into a contract, and our legitimate interest in responding to business enquiries.</p>
      </LegalSection>

      <LegalSection heading="How we store your information">
        <p>Enquiry details submitted through this site are stored securely, and an email notification is sent to our team. We retain enquiry information only for as long as necessary to respond to and follow up on your request.</p>
      </LegalSection>

      <LegalSection heading="Your rights">
        <p>Under UK data protection law you have rights over your personal data, including the right to access, correct, or request deletion of your information. To exercise these rights, contact us at <a className="text-teal-700 font-semibold" href="mailto:info@ayobell.com">info@ayobell.com</a>.</p>
      </LegalSection>

      <LegalSection heading="Contact us">
        <p>For any questions about this Privacy Policy or how we handle your information, email <a className="text-teal-700 font-semibold" href="mailto:info@ayobell.com">info@ayobell.com</a>.</p>
      </LegalSection>
    </LegalShell>
  );
}
